import { Button, Drawer } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { memo } from 'react';
import GenericSelectFilter from './items/GenericSelectFilter';
import DateRangeFilter from '../ui/filters/items/DateRangeFilter';
import NumberRangeFilter from './items/NumberRangeFilter';

const AccountMoneyFilterDrawer = ({ open, setOpen, isLoading = false }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleResetFiler = () => {
    navigate(location.pathname, { replace: true });
  };

  return (
    <Drawer
      anchor='left'
      open={open}
      onClose={() => setOpen(false)}
      PaperProps={{
        sx: { padding: '18px', background: 'transparent', boxShadow: 'none' },
      }}
    >
      <div className='dashboard-filter-drawer-wrapper !pt-2 first-letter bg-white h-full rounded-lg border border-[#E5E9EB]'>
        <div className='mb-3 text-end flex justify-between items-center border-b'>
          <div className='text-[16px] leading-[16px] font-semibold'>Filter</div>
          <Button
            color='error'
            // variant='outlined'
            className='!-mr-[5px]'
            size='small'
            disabled={isLoading}
            onClick={() => handleResetFiler()}
          >
            Tozalash
          </Button>
        </div>
        <GenericSelectFilter
          query='account_id'
          path='/dictionary/selfaccounts'
          label='Kassa'
        />
        <GenericSelectFilter
          query='category_id'
          path='/dictionary/product-category'
          label='Kategoriya'
        />
        <GenericSelectFilter
          query='supplier_id'
          path='/dictionary/partners'
          label='Hamkor'
        />
        <GenericSelectFilter
          query='staff_id'
          path='/dictionary/staffs'
          label="Mas'ul hodim"
        />
        <DateRangeFilter
          size='small'
          disabled={isLoading}
          labels={{
            start: 'Sanadan',
            end: 'gacha',
          }}
        />
        <NumberRangeFilter
          size='small'
          disabled={isLoading}
          labels={{
            from: 'UZS dan',
            till: 'gacha',
          }}
          queries={{
            from: 'sum_from',
            till: 'sum_till',
          }}
        />
        <NumberRangeFilter
          size='small'
          disabled={isLoading}
          labels={{
            from: 'USD($) dan',
            till: 'gacha',
          }}
          queries={{
            from: 'usd_from',
            till: 'usd_till',
          }}
        />
      </div>
    </Drawer>
  );
};
export default memo(AccountMoneyFilterDrawer);
